import { seoController } from './seo';
import { settingsController } from './settings';

export default {
  seo: seoController,
  settings: settingsController,
};
